import { render, staticRenderFns } from "./ServiceFee.vue?vue&type=template&id=78c4efbd&scoped=true&"
import script from "./ServiceFee.vue?vue&type=script&lang=ts&"
export * from "./ServiceFee.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceFee.vue?vue&type=style&index=0&id=78c4efbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4efbd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseClickedCheckbox: require('/usr/www/nuxt/components/Base/BaseClickedCheckbox.vue').default})
